exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.menu_links[data-v-888a795a]{cursor:pointer}.price-wrap[data-v-888a795a]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:2px}.old-price[data-v-888a795a]{opacity:.8;font-size:14px}.new-price[data-v-888a795a]{font-size:20px;font-weight:500}", ""]);

// exports
